import { render, staticRenderFns } from "./InspectorInput.vue?vue&type=template&id=9b4f8942&"
import script from "./InspectorInput.vue?vue&type=script&lang=js&"
export * from "./InspectorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports